export enum Lob {
  BIKE = 'bike',
  CAR = 'car',
  HEALTH = 'health',
  TRAVEL = 'travel',
  LIFE = 'life',
}
